import type { SVGProps } from "react";
import * as React from "react";

const SvgArrowUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.293 16.293a1 1 0 1 0 1.414 1.414zM17 7h1a1 1 0 0 0-1-1zM7 6a1 1 0 0 0 0 2zm9 11a1 1 0 1 0 2 0zm-8.293.707 10-10-1.414-1.414-10 10zM7 8h10V6H7zm9-1v10h2V7z"
    />
  </svg>
);
export default SvgArrowUpRight;
